import React from 'react';

import {CircularProgress} from "@mui/joy";

// components
import BaseApi from "../../utils/BaseApi";
import withRouter from "../../utils/withRouter";
import CommonPaginatedTable from "../Common/CommonPaginatedTable";
import ChecklistQuestionCreate from "./ChecklistQuestionCreate";
import ChecklistQuestionUpdate from "./ChecklistQuestionUpdate";


class ChecklistQuestionList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            checklistQuestions: null,
            pages: null,
        };
    }

    async componentDidMount() {
        await this.retrieveChecklistQuestions();
    }

    async componentDidUpdate(prevProps, prevState, snapshot){
        if (prevProps !== this.props){
            await this.retrieveChecklistQuestions();
        }
    }

    async retrieveChecklistQuestions() {
        const url = 'checklist_question/';
        const api = new BaseApi();
        let params = {}
        if (this.props.params.pageNumber){
            params['page'] = this.props.params.pageNumber;
        }
        let response = await api.get(url, params);
        if (response.status === 404){
            params['page'] = 1;
        }
        response = await api.get(url, params);
        this.setState(
            {
                checklistQuestions: response.data.results,
                pages: response.data.total_pages,
            }
        );
    }

    render() {
        if (!this.state.checklistQuestions) {
            return (<CircularProgress/>)
        }
        if (!this.state.pages) {
            return (<CircularProgress/>)
        }
        return (
            <CommonPaginatedTable
                title={'Вопросы чек-листов'}
                url={'admin/checklist_question'}
                callBack={this.retrieveChecklistQuestions.bind(this)}
                extraComponents={[
                    {
                        component: ChecklistQuestionCreate,
                        componentProps: {}
                    }
                ]}
                data={this.state.checklistQuestions}
                pages={this.state.pages}
                pageNumber={this.props.params.pageNumber!==undefined?parseInt(this.props.params.pageNumber):1}
                fields={[
                    {
                        title: 'Название',
                        name: 'title',
                        visible: true,
                    },
                    {
                        title: '',
                        visible: true,
                        component: ChecklistQuestionUpdate,
                        componentProps: {
                        },
                        callBack: this.retrieveChecklistQuestions.bind(this),
                    },
                    {
                        title: 'Создано',
                        name: 'created_on',
                        visible: true,
                    },
                    {
                        title: 'Обновлено',
                        name: 'updated_on',
                        visible: true,
                    },
                ]
                }
            />
        )
    }
}

export default withRouter(ChecklistQuestionList)
